import { styled } from "@mui/material";
import Avatar from "@mui/material/Avatar";
import CircularProgress from "@mui/material/CircularProgress";
import { skipToken } from "@reduxjs/toolkit/query";
import { useGetTeamAvatarQuery } from "marketplace/teams/_api/marketplace-team-api";
import Team from "marketplace/teams/team";

const StyledAvatar = styled(Avatar)<{ disabled?: boolean }>(({ disabled }) => ({
  opacity: disabled ? 0.5 : 1,
}));
const LoadingProgress = styled(CircularProgress)(({ theme }) => ({
  color: theme.palette.grey[theme.palette.mode === "light" ? 200 : 700],
  height: "75%",
  width: "75%",
}));

type TeamAvatarProps = {
  className?: string;
  team?: Team;
  disabled?: boolean;
};

export default function TeamAvatar(props: Readonly<TeamAvatarProps>) {
  const { className, team, disabled } = props;

  const { data: base64AvatarData, isLoading: isLoadingAvatar, isError: errorLoadingAvatar } = useGetTeamAvatarQuery(
    team?.profile.avatarId && team.id ? { teamId: team.id.value } : skipToken,
  );

  return (
    <>
      {base64AvatarData ? (
        <StyledAvatar className={className} disabled={disabled} src={base64AvatarData}>
          {!base64AvatarData && isLoadingAvatar && !errorLoadingAvatar && <LoadingProgress disableShrink />}
        </StyledAvatar>
      ) : (
        <Avatar className={className} />
      )}
    </>
  );
}
